import { LitElement, html } from 'lit';
import { property, query, customElement } from 'lit/decorators.js';
import { InputWidthValues } from '../../../../../../../../ui/gzInput';
import { GzInputWebComponent } from '../../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { WEB_COMPONENT_POLICY_PANEL_IMPORT_FILE_INPUT } from '../../../../../../../../webcomponents.constants';
import { styles } from '../view/styles';
import { ButtonTypes } from '../../../../../../../../ui/gzButton/types';
import { GzFormFieldWebComponent } from '../../../../../../../../ui/gzForm/formField';
import { GzInputFileWebComponent } from '../../../../../../../../ui/gzInputFile';
import { OnImportFileNameChange } from '../events/events';
import { GzInfoBoxWebComponent } from '../../../../../../../../ui/gzInfoBox';

@customElement(WEB_COMPONENT_POLICY_PANEL_IMPORT_FILE_INPUT)
export class GzPolicyUiSettingsImportFileInputWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  inputLabel = '';

  @property({ type: String, attribute: true, reflect: true })
  buttonLabel = '';

  @query('#file-name-input')
  fileNameInputComponent: GzInputWebComponent;

  @query('#file-name-form-field')
  fileNameFormField: GzFormFieldWebComponent<GzInputFileWebComponent>;

  @query('#info-box')
  infoBox: GzInfoBoxWebComponent;

  /**
   * Styles for the component.
   */
  static get styles() {
    return styles;
  }

  public setErrorMessage(message: string) {
    this.infoBox.innerText = message;
    this.infoBox.classList.remove('hidden');
  }

  public removeErrorMessage() {
    this.infoBox.classList.add('hidden');
  }

  protected render() {
    return html`
      <div class="fileInput">
        <gz-input
          id="file-name-input"
          inputWidth=${InputWidthValues.XLARGE}
          label="${this.inputLabel}"
          readonly="true"
        ></gz-input>
        <gz-form-field id="file-name-form-field">
          <gz-file-input gz-form-input @change="${this.onUserInputChange}">
            <gz-button browse-button type="${ButtonTypes.OUTLINE}">${this.buttonLabel}</gz-button>
          </gz-file-input>
        </gz-form-field>
      </div>
      <gz-info-box severity="error" id="info-box" class="hidden"></gz-info-box>
    `;
  }

  private onUserInputChange(event: CustomEvent) {
    this.fileNameInputComponent.setFormValue(event.detail.sourceEvent);
    this.dispatchEvent(new OnImportFileNameChange(event.detail.sourceEvent));
  }

  public getValue(): FileList {
    return this.fileNameFormField.value as FileList;
  }
}
